class ValidationRule {
  constructor(message) {
    this._message = message;
  }

  register(validationRules = []) {
    const validate = (val) => {
      const valid = this.validate(val);
      const message = valid ? null : this._message;
      return {
        valid,
        message
      };
    };

    validationRules.push(validate);
  }
}

export default ValidationRule;



// WEBPACK FOOTER //
// ./src/common/core/validation/validationRules/ValidationRule.js